/**
 * Created by Olexiy on 21.02.2017.
 */

(function($){
    $(document).ready(function() {

        $('.js-content-banner').each(function() {
            var $this = $(this);

            function setImageSrc() {
                var img = $this.find('img');
                var srcset = img.attr('srcset');
                var srcSetArr = srcset.split(', ');
                var srcSetArrLength = srcSetArr.length;
                var src = srcSetArr[srcSetArrLength-1];
                var n = src.indexOf(' ');
                src = src.substring(0, n !== -1 ? n : src.length);
                img.attr('src',src);
                img.removeAttr('width').removeAttr('height').removeAttr('srcset').removeAttr('sizes');
            }
            setImageSrc();
        });
    });
})(jQuery);
